/* @typescript-eslint:disable */
/* eslint:disable */
/* eslint no-use-before-define: 0 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { ensureScriptLoaded, getNonce, isNullOrWhitespace } from "../utilities";
import View from "../view";

export default class Monitoring {
  private static gaStarted = false;

  public static startHotjar(siteId: string) {
    const nonce = getNonce();

    (function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          // eslint-disable-next-line prefer-rest-params
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: siteId, hjsv: 6 };
      a = o.getElementsByTagName("head")[0];
      r = o.createElement("script");
      r.async = 1;

      if (nonce) {
        r.setAttribute('nonce', nonce);
      }  

      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
  }

  public static startLogging(instrumentationKey: string) {
    if (isNullOrWhitespace(instrumentationKey)) {
      return;
    }

    const nonce = getNonce();
/* eslint-disable no-var, no-useless-escape, no-empty, prefer-rest-params, prefer-spread, no-cond-assign */
    !(function (cfg){function e(){cfg.onInit&&cfg.onInit(n)}var x,w,D,t,E,n,C=window,O=document,b=C.location,q="script",I="ingestionendpoint",L="disableExceptionTracking",j="ai.device.";"instrumentationKey"[x="toLowerCase"](),w="crossOrigin",D="POST",t="appInsightsSDK",E=cfg.name||"appInsights",(cfg.name||C[t])&&(C[t]=E),n=C[E]||function(g){var f=!1,m=!1,h={initialize:!0,queue:[],sv:"8",version:2,config:g};function v(e,t){var n={},i="Browser";function a(e){e=""+e;return 1===e.length?"0"+e:e}return n[j+"id"]=i[x](),n[j+"type"]=i,n["ai.operation.name"]=b&&b.pathname||"_unknown_",n["ai.internal.sdkVersion"]="javascript:snippet_"+(h.sv||h.version),{time:(i=new Date).getUTCFullYear()+"-"+a(1+i.getUTCMonth())+"-"+a(i.getUTCDate())+"T"+a(i.getUTCHours())+":"+a(i.getUTCMinutes())+":"+a(i.getUTCSeconds())+"."+(i.getUTCMilliseconds()/1e3).toFixed(3).slice(2,5)+"Z",iKey:e,name:"Microsoft.ApplicationInsights."+e.replace(/-/g,"")+"."+t,sampleRate:100,tags:n,data:{baseData:{ver:2}},ver:undefined,seq:"1",aiDataContract:undefined}}var n,i,t,a,y=-1,T=0,S=["js.monitor.azure.com","js.cdn.applicationinsights.io","js.cdn.monitor.azure.com","js0.cdn.applicationinsights.io","js0.cdn.monitor.azure.com","js2.cdn.applicationinsights.io","js2.cdn.monitor.azure.com","az416426.vo.msecnd.net"],o=g.url||cfg.src,r=function(){return s(o,null)};function s(d,t){if((n=navigator)&&(~(n=(n.userAgent||"").toLowerCase()).indexOf("msie")||~n.indexOf("trident/"))&&~d.indexOf("ai.3")&&(d=d.replace(/(\/)(ai\.3\.)([^\d]*)$/,function(e,t,n){return t+"ai.2"+n})),!1!==cfg.cr)for(var e=0;e<S.length;e++)if(0<d.indexOf(S[e])){y=e;break}var n,i=function(e){var a,t,n,i,o,r,s,c,u,l;h.queue=[],m||(0<=y&&T+1<S.length?(a=(y+T+1)%S.length,p(d.replace(/^(.*\/\/)([\w\.]*)(\/.*)$/,function(e,t,n,i){return t+S[a]+i})),T+=1):(f=m=!0,s=d,!0!==cfg.dle&&(c=(t=function(){var e,t={},n=g.connectionString;if(n)for(var i=n.split(";"),a=0;a<i.length;a++){var o=i[a].split("=");2===o.length&&(t[o[0][x]()]=o[1])}return t[I]||(e=(n=t.endpointsuffix)?t.location:null,t[I]="https://"+(e?e+".":"")+"dc."+(n||"services.visualstudio.com")),t}()).instrumentationkey||g.instrumentationKey||"",t=(t=(t=t[I])&&"/"===t.slice(-1)?t.slice(0,-1):t)?t+"/v2/track":g.endpointUrl,t=g.userOverrideEndpointUrl||t,(n=[]).push((i="SDK LOAD Failure: Failed to load Application Insights SDK script (See stack for details)",o=s,u=t,(l=(r=v(c,"Exception")).data).baseType="ExceptionData",l.baseData.exceptions=[{typeName:"SDKLoadFailed",message:i.replace(/\./g,"-"),hasFullStack:!1,stack:i+"\nSnippet failed to load ["+o+"] -- Telemetry is disabled\nHelp Link: https://go.microsoft.com/fwlink/?linkid=2128109\nHost: "+(b&&b.pathname||"_unknown_")+"\nEndpoint: "+u,parsedStack:[]}],r)),n.push((l=s,i=t,(u=(o=v(c,"Message")).data).baseType="MessageData",(r=u.baseData).message='AI (Internal): 99 message:"'+("SDK LOAD Failure: Failed to load Application Insights SDK script (See stack for details) ("+l+")").replace(/\"/g,"")+'"',r.properties={endpoint:i},o)),s=n,c=t,JSON&&((u=C.fetch)&&!cfg.useXhr?u(c,{method:D,body:JSON.stringify(s),mode:"cors"}):XMLHttpRequest&&((l=new XMLHttpRequest).open(D,c),l.setRequestHeader("Content-type","application/json"),l.send(JSON.stringify(s)))))))},a=function(e,t){m||setTimeout(function(){!t&&h.core||i()},500),f=!1},p=function(e){var n=O.createElement(q); if (nonce) { n.setAttribute('nonce', nonce); }  e=(n.src=e,t&&(n.integrity=t),n.setAttribute("data-ai-name",E),cfg[w]);return!e&&""!==e||"undefined"==n[w]||(n[w]=e),n.onload=a,n.onerror=i,n.onreadystatechange=function(e,t){"loaded"!==n.readyState&&"complete"!==n.readyState||a(0,t)},cfg.ld&&cfg.ld<0?O.getElementsByTagName("head")[0].appendChild(n):setTimeout(function(){O.getElementsByTagName(q)[0].parentNode.appendChild(n)},cfg.ld||0),n};p(d)}cfg.sri&&(n=o.match(/^((http[s]?:\/\/.*\/)\w+(\.\d+){1,5})\.(([\w]+\.){0,2}js)$/))&&6===n.length?(d="".concat(n[1],".integrity.json"),i="@".concat(n[4]),l=window.fetch,t=function(e){if(!e.ext||!e.ext[i]||!e.ext[i].file)throw Error("Error Loading JSON response");var t=e.ext[i].integrity||null;s(o=n[2]+e.ext[i].file,t)},l&&!cfg.useXhr?l(d,{method:"GET",mode:"cors"}).then(function(e){return e.json()["catch"](function(){return{}})}).then(t)["catch"](r):XMLHttpRequest&&((a=new XMLHttpRequest).open("GET",d),a.onreadystatechange=function(){if(a.readyState===XMLHttpRequest.DONE)if(200===a.status)try{t(JSON.parse(a.responseText))}catch(e){r()}else r()},a.send())):o&&r();try{h.cookie=O.cookie}catch(k){}function e(e){for(;e.length;)!function(t){h[t]=function(){var e=arguments;f||h.queue.push(function(){h[t].apply(h,e)})}}(e.pop())}var c,u,l="track",d="TrackPage",p="TrackEvent",l=(e([l+"Event",l+"PageView",l+"Exception",l+"Trace",l+"DependencyData",l+"Metric",l+"PageViewPerformance","start"+d,"stop"+d,"start"+p,"stop"+p,"addTelemetryInitializer","setAuthenticatedUserContext","clearAuthenticatedUserContext","flush"]),h.SeverityLevel={Verbose:0,Information:1,Warning:2,Error:3,Critical:4},(g.extensionConfig||{}).ApplicationInsightsAnalytics||{});return!0!==g[L]&&!0!==l[L]&&(e(["_"+(c="onerror")]),u=C[c],C[c]=function(e,t,n,i,a){var o=u&&u(e,t,n,i,a);return!0!==o&&h["_"+c]({message:e,url:t,lineNumber:n,columnNumber:i,error:a,evt:C.event}),o},g.autoExceptionInstrumented=!0),h}(cfg.cfg),(C[E]=n).queue&&0===n.queue.length?(n.queue.push(e),n.trackPageView({})):e();})({
      src: "https://js.monitor.azure.com/scripts/b/ai.3.gbl.min.js",
      // name: "appInsights", // Global SDK Instance name defaults to "appInsights" when not supplied
      // ld: 0, // Defines the load delay (in ms) before attempting to load the sdk. -1 = block page load and add to head. (default) = 0ms load after timeout,
      // useXhr: 1, // Use XHR instead of fetch to report failures (if available),
      // dle: true, // Prevent the SDK from reporting load failure log
      crossOrigin: "anonymous", // When supplied this will add the provided value as the cross origin attribute on the script tag
      // onInit: null, // Once the application insights instance has loaded and initialized this callback function will be called with 1 argument -- the sdk instance (DON'T ADD anything to the sdk.queue -- As they won't get called)
      // sri: false, // Custom optional value to specify whether fetching the snippet from integrity file and do integrity check
      cfg: { // Application Insights Configuration
        instrumentationKey: instrumentationKey,
        autoTrackPageVisitTime: false
    }});

    /* eslint-enable no-var, no-useless-escape, no-empty, prefer-rest-params, prefer-spread */
  }

  public static startGA() {
    this.gaStarted = true;
  }

  public static gaEvent(label: string, value: number) {
    this.gtagEvent(label, value);
  }

  public static pensionLabDashboardEvent(view: View) {
    this.gaEvent("PensionLabDashboard", view);
  }

  public static startOlark() {
    const nonce = getNonce();

    (function (o, l, a, r, k, y) {
      if (o.olark) return;
      r = "script";
      y = l.createElement(r);
      r = l.getElementsByTagName(r)[0];
      y.async = 1;

      if (nonce) {
        y.setAttribute('nonce', nonce);
      }

      y.src = "https://" + a;
      r.parentNode.insertBefore(y, r);
      y = o.olark = function () {
        // eslint-disable-next-line prefer-rest-params
        k.s.push(arguments);
        k.t.push(+new Date());
      };
      y.extend = function (i, j) {
        y("extend", i, j);
      };
      y.identify = function (i) {
        y("identify", (k.i = i));
      };
      y.configure = function (i, j) {
        y("configure", i, j);
        k.c[i] = j;
      };
      k = y._ = { s: [], t: [+new Date()], c: {}, l: a };
    })(window, document, "static.olark.com/jsclient/loader.js");
    /* custom configuration goes here (www.olark.com/documentation) */
    olark.identify("4307-388-10-6316");
  }

  public static startFacebookPixel() {
    const nonce = getNonce();

    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(...args){n.callMethod?
    n.callMethod(...args):n.queue.push(args)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;

    if (nonce) {
      t.setAttribute('nonce', nonce);
    }

    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');

    window.fbq('init', '349948565696837');
  }

  public static startBing() {
    const nonce = getNonce();

    (function (w, d, t, r, u) {
      let f, n, i;
      w[u] = w[u] || []; 
      f = function () {
        const o = { ti: "25080635" };
        o.q = w[u], 
        w[u] = new UET(o), 
        w[u].push("pageLoad")
      };
      n = d.createElement(t);
      n.src = r;
      n.async = 1;
      if (nonce) {
        n.setAttribute('nonce', nonce);
      }
      n.onload = n.onreadystatechange = function () {
        const s = this.readyState;
        s && s !== "loaded" && s !== "complete" || (f(), n.onload = n.onreadystatechange = null)
      };
      i = d.getElementsByTagName(t)[0];
      i.parentNode.insertBefore(n, i);
    })(window, document, "script", "https://bat.bing.com/bat.js", "uetq");
  }

  public static startMoosend() {
    const nonce = getNonce();

    !function(t, n, e, o, a) {
      function d(t) {
        const n = ~~(Date.now() / 3e5);
        o = document.createElement(e);
        o.async = !0;
        if (nonce) {
          o.setAttribute('nonce', nonce);
        }  
        o.src = t + "?ts=" + n;
        const a = document.getElementsByTagName(e)[0];
        a.parentNode.insertBefore(o, a);
      }
      t.MooTrackerObject = a;
      t[a] = t[a] || function(...args) {
        return t[a].q ? void t[a].q.push(args) : void (t[a].q = args);
      };
      window.attachEvent
        ? window.attachEvent("onload", d.bind(this, o))
        : window.addEventListener("load", d.bind(this, o), !1);
    }(window, document, "script", "https://cdn.stat-track.com/statics/moosend-tracking.min.js", "mootrack");
  }

  public static gaSetUserProperties(userId: number, properties: Record<string, string>) {
    if (!window.gtag || !this.gaStarted) {
      return;
    }

    try {
      window.gtag('set', { user_id: userId.toString() });

      if (Object.keys(properties).length > 0) {
        window.gtag('set', 'user_properties', properties);
      }

      // eslint-disable-next-line no-empty
    } catch (error) { }
  }

  public static gaSendPageView() {
    if (!window.gtag || !this.gaStarted) {
      return;
    }

    try {
      window.gtag('event', 'page_view');
      // eslint-disable-next-line no-empty
    } catch (error) { }
  }

  private static gtagEvent(label: string, value: number) {
    if (!window.gtag || !this.gaStarted) {
      return;
    }

    const action = "click";
    const category = "Internal Link";

    try {
      window.gtag('event', action, {
        'event_category': category,
        'event_label': label,
        'value': value
      });
      // eslint-disable-next-line no-empty
    } catch (error) { }
  }

  public static trackEvent<K extends keyof EventMap>(name: K, payload: EventMap[K]): void {
    const dataLayer = (window as any).dataLayer;

    if (!Array.isArray(dataLayer)) {
      return;
    }

    dataLayer.push({
      event: name,
      ...payload,
    });
  }
}
